import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";
import { CtepEctError } from "@/utils/ctep/ctep-ect-error";
import { CtepSaleResult } from "@/utils/ctep/ctep-sale-result";
import { ICtepService } from "@/utils/ctep/ctep-service";
import { CtepTerminal } from "@/utils/ctep/ctep-terminal";
import { AxiosError } from "axios";
import { AuthService } from ".";
import { CtepSettings } from "@/utils/ctep/ctep-settings";
import { MODULE } from "@/config/modules";

function getSettingsKey():string{
	return `electron-ctep-settings-${AuthService.wfDossier.id}`;
}


export class CtepService implements ICtepService {
	public static readonly url:string = `${ServerConfig.host}/ctep`;
	public readonly terminalId:string;
	private static lastUsedTerminalId:string = "";
	public get url():string{
		return `${CtepService.url}/${encodeURIComponent(this.terminalId)}`;
	}

	private constructor(terminalId:string) {
		this.terminalId = terminalId;
	}

	public static async getTerminals():Promise<CtepTerminal[]> {
		let result = await Axios.get(`${this.url}/terminals`);
		return ((result.data || []) as any[]).map(r=> new CtepTerminal(r));
	}

	public static createService(terminalId:string):CtepService {
		return new CtepService(terminalId);
	}

	private ectErrorHandler(err:any){
		let error = err as AxiosError;
		if (error.response){
			if (typeof(error.response.data) == "object") {
				throw new CtepEctError(error.response.data);
			}
		}
		throw err;
	}

	async sendSaleTransaction(amount: number, reference: string): Promise<CtepSaleResult> {
		CtepService.lastUsedTerminalId = this.terminalId;
		let result = await Axios.post(`${this.url}/send-sale-transaction`, {amount, reference}, {timeout: 90000});
		if (result.data.error) {
			throw new CtepEctError(result.data.error);
		}
		return new CtepSaleResult(result.data);
	}

	async cancelSale():Promise<void> {
		let result = await Axios.post(`${this.url}/cancel-sale`);
		if (result.data.error) {
			throw new CtepEctError(result.data.error);
		}
	}

	async lastTransaction():Promise<CtepSaleResult>{
		let result = await Axios.get(`${this.url}/last-transaction`);
		if (result.data.error) {
			throw new CtepEctError(result.data.error);
		}
		return new CtepSaleResult(result.data);
	}

	public static getSettings():CtepSettings{
		let storedJsonString =  localStorage.getItem(getSettingsKey());
		let storedSettings = null;
		if (storedJsonString) {
			storedSettings = JSON.parse(storedJsonString);
		}
		return new CtepSettings(storedSettings);
	}

	public static setSettings(settings:CtepSettings){
		localStorage.setItem(getSettingsKey(), JSON.stringify(settings.getJSON()));
	}

	public static hasModule():boolean {
		return AuthService.hasModule(MODULE.KOPPELING_MET_BANCONTACT);
	}

	public static lastTranslaction():Promise<CtepSaleResult>{
		let terminalId = this.getSettings().defaultTerminalId;
		if (this.lastUsedTerminalId) {
			terminalId = this.lastUsedTerminalId;
		}
		if (!terminalId) {
			throw new Error("No last transaction");
		}
		return CtepService.createService(terminalId).lastTransaction();
	}

	public static async downloadCtepTicketAsPdf(ticket:string):Promise<Blob>{
		let result = await Axios.post(`${this.url}/ticket-to-pdf`, {Ticket: ticket}, {responseType: "blob"});
		return result.data;
	}
}
